import { Injectable } from '@angular/core';
import { ITaskTypeCategory } from '@common/interfaces/issueTypeWorflow';
import { Topics } from '@common/interfaces/topics';
import { EntityState, EntityStore, ID, Store } from '@datorama/akita';
import { PersistedStoreConfig } from '@persistence/persisted-store-config';

export interface TaskTypeCategoryState extends EntityState<ITaskTypeCategory, string> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.TYPE_CATEGORY , realtimeEntity: 'TypeCategoryEntity'})
export class TaskTypeCategoryStore extends EntityStore<TaskTypeCategoryState> {
  constructor() {
    super([]);
  }
}
